/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getBidding } from 'services/actions/bidding_actions';
import { BiddingData } from 'store/modules/bidding_store/types';
import { setFormQuote } from 'store/modules/conlicitaseg_store/actions';
import InsuranceStepIndicator from 'components/atoms/insurance_step_indicator';
import useQuoteFlow from 'hooks/useQuoteFlow';

const ConlicitasegData: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathFor, stepIndicatorProps } = useQuoteFlow();

  const [biddingId, setBiddingId] = useState<number | undefined>(undefined);
  const [biddingSelected, setBiddingSelected] = useState<BiddingData | null>(null);
  const [biddingError, setBiddingError] = useState<boolean>(false);
  const [hasFailedLookup, setHasFailedLookup] = useState<boolean>(false);
  const [loadedBidding, setLoadedBidding] = useState<boolean>(false);

  useEffect(() => {
    if (biddingSelected !== null) {
      dispatch(
        setFormQuote({
          bidding_id: biddingId,
          bidding_modality: biddingSelected.modality.nome,
          bidding_edict: biddingSelected.edital.split('/').slice(1).join('/'),
        }),
      );
      history.push(pathFor('licitacao'));
    }
  }, [biddingSelected]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!biddingId) {
      history.push(pathFor('licitacao'));
    }

    if (hasFailedLookup) {
      history.push(pathFor('licitacao'));
    }

    await getBidding(biddingId?.toString() || '', (data) => {
      setLoadedBidding(true);
      setBiddingSelected(data);
    });

    if (!loadedBidding) {
      setBiddingError(true);
      setHasFailedLookup(true);
    }
  };

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions py-5 px-md-5">
        <div className="row justify-content-center mt-5">
          <div className="col-12 mx-auto">
            <div className="row align-items-stretch">
              <div className="col-md-9">
                <div className="shadow-sm p-4 bg-white rounded">
                  <h4 className="mb-4">
                    Use o Nº Conlicitação para o preenchimento automático de algumas informações
                  </h4>
                  <p>
                    Esse campo é opcional, mas com ele vai facilitar o preenchimento das informações
                    necessárias.{' '}
                  </p>
                  <p>Você consegue essa informação no card da licitação.</p>
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <div className="col-md-4 px-0">
                        <label htmlFor="bidding_id">N° Conlicitação</label>
                        <input
                          type="text"
                          inputMode="numeric"
                          className="form-control"
                          id="bidding_id"
                          value={biddingId ?? ''}
                          onChange={(e) =>
                            setBiddingId(
                              e.target.value.replace(/\D/g, '')
                                ? Number(e.target.value)
                                : undefined,
                            )
                          }
                        />
                        {biddingError && (
                          <div className="mt-2 p-3 border border-danger rounded bg-light text-left w-100">
                            <div className="d-flex align-items-center">
                              <i className="material-icons text-danger mr-2">error_outline</i>
                              <span className="text-danger font-weight-bold">
                                O número do conlicitação não foi encontrado. Você pode continuar sem
                                ele ou rever o valor digitado.
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => history.push('/conlicitaseg')}
                        >
                          Cancelar
                        </button>
                        <button type="submit" className="btn btn-primary ml-2">
                          Continuar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-md-3 d-none d-md-block">
                <InsuranceStepIndicator {...stepIndicatorProps('motivo')} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConlicitasegData;
